import PropTypes from 'prop-types';
import React from 'react';
import styles from './BoxIcon.module.css';

const boxPath =
  'M17 15.529l-1.084.619-6.693 3.826v-8.891l.331-.189.753-.43L17 6.638v8.891zM8.831 9.655l-.331.189-.332-.189-.752-.431L.723 5.399l6.693-3.826L8.5.953l1.084.62 6.693 3.825-6.693 3.826-.753.431zm-2.138.809l.753.43.331.189v8.891l-6.693-3.826L0 15.529v-8.89l6.693 3.825z';
const outlineBoxPath =
  'M16.986 13.346l-1.336-.763-.71-.406-.001-6.292a.461.461 0 0 0-.234-.401L9.2 2.338V.001l7.786 4.448v8.897zM9.2 3.408l4.335 2.477L9.2 8.362l-.488.279-.214.123-.215-.123-.488-.279L3.46 5.885l4.335-2.477.703-.401.702.401zM2.056 5.885v6.292L.01 13.346V4.449L7.795.001v2.337L2.29 5.484a.463.463 0 0 0-.234.401zm.936 6.559V6.688l4.335 2.477.488.278.214.123v5.756l-4.334-2.477h-.001l-.702-.401zm5.974 2.878V9.566l.214-.123.488-.278 4.335-2.477v5.756l-.702.401-4.335 2.477zm-.702 1.204a.47.47 0 0 0 .468 0l5.505-3.146.711.406 1.335.763-7.785 4.448-7.786-4.448 2.046-1.169 5.506 3.146z';
const outlinePath =
  'm16.986,13.346l-1.336,-0.763l-0.71,-0.406l-0.001,-6.292a0.461,0.461 0 0 0 -0.234,-0.401l-5.505,-3.146l0,-2.337l7.786,4.448l0,8.897zm-14.93,-7.461l0,6.292l-2.046,1.169l0,-8.897l7.785,-4.448l0,2.337l-5.505,3.146a0.463,0.463 0 0 0 -0.234,0.401zm6.208,10.641a0.47,0.47 0 0 0 0.468,0l5.505,-3.146l0.711,0.406l1.335,0.763l-7.785,4.448l-7.786,-4.448l2.046,-1.169l5.506,3.146z';

export const BoxIcon = ({ showOutline, outlineOnly, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="20"
    className={styles.svg}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d={showOutline ? (outlineOnly ? outlinePath : outlineBoxPath) : boxPath}
    />
  </svg>
);

BoxIcon.propTypes = {
  showOutline: PropTypes.bool,
  outlineOnly: PropTypes.bool,
};

BoxIcon.defaultProps = {
  showOutline: false,
  outlineOnly: false,
};
